<div class="flex flex-col gap-2 mb-4">
  <label class="text-sm font-medium text-gray-700">
    {{ props.label }} @if (props.required && !isReadonly) {
    <span class="text-red-500">*</span>
    }
  </label>

  @if (!isReadonly) {
  <!-- Edit Mode: Show file input and list of selected files -->
  <div class="flex flex-col gap-3">
    <!-- Selected Files List -->
    @if (selectedFiles.length > 0) {
    <div class="flex flex-col gap-2">
      @for (selectedFile of selectedFiles; track selectedFile.index) {
      <div class="flex items-center gap-2 p-2 bg-gray-50 rounded-md">
        <i class="fa-solid fa-file text-gray-500"></i>
        <span class="flex-1 text-sm text-gray-700 truncate">{{ selectedFile.file.name }}</span>
        <span class="text-xs text-gray-500">({{ formatFileSize(selectedFile.file.size) }})</span>
        <button mat-icon-button type="button" (click)="removeFile(selectedFile.index)" title="Remove file">
          <mat-icon color="warn">delete</mat-icon>
        </button>
      </div>
      }
    </div>
    }

    <!-- File Input (only show if can add more files) -->
    @if (canAddMoreFiles) {
    <div class="flex flex-col gap-1">
      <input
        type="file"
        [accept]="props['accept'] || '.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg'"
        (change)="onFileSelected($event)"
        class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
        #fileInput
      />
      <span class="text-xs text-gray-500">
        {{ selectedFiles.length }} of {{ maxFiles }} files selected. Max 10 MB per file.
      </span>
    </div>
    } @else {
    <span class="text-xs text-gray-500">Maximum number of files ({{ maxFiles }}) reached.</span>
    }

    <!-- Errors -->
    @for (error of fileSizeErrors | keyvalue; track error.key) {
    <div class="text-sm text-red-500">{{ error.value }}</div>
    } @if (props.required && formControl.touched && selectedFiles.length === 0) {
    <div class="text-sm text-red-500">At least one file is required</div>
    }
  </div>
  } @else {
  <!-- Readonly Mode: Show download links for submitted files -->
  @if (submittedFiles.length > 0) {
  <div class="flex flex-col gap-2">
    @for (submittedFile of submittedFiles; track submittedFile.index) {
    <div class="flex items-center gap-2">
      <button
        mat-raised-button
        color="primary"
        type="button"
        class="shrink-0"
        (click)="downloadSubmittedFile(submittedFile.index)"
        [disabled]="downloadingIndex() === submittedFile.index"
      >
        <span class="inline-flex items-center gap-2">
          @if (downloadingIndex() === submittedFile.index) {
          <mat-spinner diameter="16"></mat-spinner>
          } @else {
          <i class="fa-solid fa-download"></i>
          }
          <span>Download</span>
        </span>
      </button>
      <span class="text-sm text-gray-500">{{ getFileName(submittedFile.path) }}</span>
    </div>
    }
  </div>
  } @else {
  <div class="text-sm text-gray-500 italic">No files submitted</div>
  } }
</div>
